import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function VariantAttributesPage() {
    const columns = useMemo(() => [
        { key: 'name', label: 'Variant' },
        { key: 'values', label: 'Values', render: (row) => (row.values || []).join(', ') || '-' },
        { key: 'created_at', label: 'Created Date', render: (row) => new Date(row.created_at).toLocaleDateString() },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Variant Attributes"
            type="variant"
            columns={columns}
            fields={[
                { name: 'name', label: 'Variant Name' },
                { name: 'values', label: 'Values', type: 'tags', placeholder: 'Comma separated values', helpText: 'Example: Red, Blue, Green' },
            ]}
            buildPayload={(form) => ({
                name: form.name,
                status: form.status,
                metadata: {
                    values: String(form.values || '').split(',').map((item) => item.trim()).filter(Boolean),
                },
            })}
        />
    );
}
